var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.646,
    height: 19.439,
    viewBox: "0 0 17.646 19.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.75 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.294,6H18.852a1.794,1.794,0,0,1,1.794,1.794V20.352a1.794,1.794,0,0,1-1.794,1.794H6.294A1.794,1.794,0,0,1,4.5,20.352V7.794A1.794,1.794,0,0,1,6.294,6Z",
    transform: "translate(0 -1.206)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,3V6.588",
    transform: "translate(-7.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,3V6.588",
    transform: "translate(-3.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.5,15H20.646",
    transform: "translate(0 -4.824)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender_icon.0e452cf5962828abf813c9402a179ef5.svg";
export { ForwardRef as ReactComponent };